import { useMutation, useQueryClient } from "@tanstack/react-query";
import { cancellationService, CancellationResult } from "@/services/orders/cancellation-service";
import { CancellationReason } from "@/services/orders/cancellation.types";
import { Order } from "@/services/orders/orders.types";

interface CancelOrderVariables {
  orderId: string;
  reason: CancellationReason;
}

export const useCancelOrderMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<CancellationResult, Error, CancelOrderVariables>({
    mutationFn: ({ orderId, reason }) => cancellationService.cancelOrder(orderId, reason),
    onSuccess: (result, { orderId }) => {
      if (result.success) {
        queryClient.setQueryData<Order[]>(["orders", "amznham"], (old) =>
          old?.map((order) => (order.orderId === orderId ? { ...order, status: "CANCELLED" } : order)) ?? []
        );
      }
    },
  });
};
